import {useAppDispatch, useAppSelector} from 'hooks'
import {
  eegSummaryBrainFunction,
  eegSummaryFiveIndicators,
  selectItems,
  selectItemsBrainFunction,
  eegSummaryBrainFunctionMapping,
  selectItemsBrainFunctionMapping,
} from 'features/analysis/eegSummaryReportSlice'
import {
  EegSummaryReportType,
  FetchIndividualSummaryReportRequest,
} from 'api/analysisApi'

export default function useEegSummaryReport() {
  const dispatch = useAppDispatch()

  const items = useAppSelector(selectItems)
  const itemsBrainFunction = useAppSelector(selectItemsBrainFunction)
  const itemsBrainFunctionMapping = useAppSelector(
    selectItemsBrainFunctionMapping,
  )

  const getReport = (payload: EegSummaryReportType) => {
    return dispatch(eegSummaryFiveIndicators(payload))
  }
  const getReportBrainFunction = (payload: EegSummaryReportType) => {
    return dispatch(eegSummaryBrainFunction(payload))
  }
  const getReportBrainFunctionMapping = (
    payload: FetchIndividualSummaryReportRequest,
  ) => {
    return dispatch(eegSummaryBrainFunctionMapping(payload))
  }
  return {
    items,
    itemsBrainFunction,
    itemsBrainFunctionMapping,
    getReport,
    getReportBrainFunction,
    getReportBrainFunctionMapping,
  }
}
